<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chichristensen0007#prog">Prologue</a></p>
<p class="toc"><a class="xref" href="#/chichristensen0008#ch01">1.  Tonal Imaginations</a></p>
<p class="toc"><a class="xref" href="#/chichristensen0009#ch02">2.  Chant</a></p>
<p class="toc"><a class="xref" href="#/chichristensen0010#ch03">3.  Origins</a></p>
<p class="toc"><a class="xref" href="#/chichristensen0011#ch04">4.  Song</a></p>
<p class="toc"><a class="xref" href="#/chichristensen0012#ch05">5.  Orienting Tonality</a></p>
<p class="toc"><a class="xref" href="#/chichristensen0013#ch06">6.  Theory</a></p>
<p class="toc"><a class="xref" href="#/chichristensen0014#ch07">7.  Tonal Futures</a></p>
<p class="toc"><a class="xref" href="#/chichristensen0015#epil">Epilogue</a></p>
<p class="tocbmf"><a class="xref" href="#/chichristensen0016#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chichristensen0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chichristensen0019#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chichristensen0020#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-christensen-0006.vue?c5729320